export default "__VITE_ASSET__CBM5igSL__"